<template>
  <div class="container-fluid">
    <div id="brs" class="contents">
      <tab />
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <b-form @submit="onSubmit">
            <div class="row row-cols-2 row-cols-lg-4 g-2 mb-4">
              <div class="col-12 col-sm-6">
                <select
                  aria-label="search select"
                  v-model="searchData.searchtype"
                >
                  <option value="G.fit_goods_nm">
                    {{ $t("filter.brandroom.goods_name") }}
                  </option>
                  <option value="GS.fit_goods_shaft_nm">
                    {{ $t("filter.brandroom.club_name") }}
                  </option>
                  <option value="P.nickname">
                    {{ $t("filter.brandroom.nickname") }}
                  </option>
                  <option value="B.fit_brand_nm">
                    {{ $t("filter.brandroom.brand_name") }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-sm-6">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('text.common.enter_search_term')"
                    :aria-label="$t('text.common.enter_search_term')"
                    v-model="searchData.searchname"
                  />
                  <button
                    class="btn btn-primary btn-lg icon-search"
                    type="submit"
                  ></button>
                </div>
              </div>
              <div class="col">
                <select v-model="searchData.findex">
                  <option value="R.reg_date" selected>
                    {{ $t("filter.brandroom.sort_by_date") }}
                  </option>
                  <option value="R.state_cd">
                    {{ $t("filter.brandroom.sort_by_status") }}
                  </option>
                  <option value="G.fit_goods_nm">
                    {{ $t("filter.brandroom.sort_by_goods_name") }}
                  </option>
                </select>
              </div>
              <div class="col">
                <select v-model="searchData.pagesize">
                  <option value="10">
                    {{ $t("filter.common.10perpage") }}
                  </option>
                  <option value="20">
                    {{ $t("filter.common.20perpage") }}
                  </option>
                  <option value="30">
                    {{ $t("filter.common.30perpage") }}
                  </option>
                </select>
              </div>
            </div>
          </b-form>
          <table class="table board">
            <thead>
              <tr>
                <th class="col-auto d-lg-table-cell d-none">
                  {{ $t("title.common.number") }}
                </th>
                <th class="col-auto d-lg-table-cell">
                  {{ $t("title.brandroom.goods_name") }}
                </th>
                <th class="col-auto d-lg-table-cell d-none">
                  {{ $t("title.brandroom.club_infromation") }}
                </th>
                <th class="col-auto d-lg-table-cell text-center">
                  {{ $t("title.common.status") }}
                </th>
                <th class="col-auto d-lg-table-cell d-none">
                  {{ $t("title.common.nickname") }}
                </th>
                <th class="col-auto d-lg-table-cell d-none">
                  {{ $t("title.brandroom.brand_name") }}
                </th>
                <th class="col-auto d-lg-table-cell d-none">
                  {{ $t("title.common.registration_date") }}
                </th>
                <th class="th-arrow">&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="items.length">
              <template v-for="(item, index) in items">
                <tr :key="index">
                  <td class="col-auto d-lg-table-cell d-none">
                    {{ item.no }}
                  </td>
                  <td class="col-auto d-lg-table-cell text-start">
                    <router-link
                      :to="{
                        name: 'FittingSwingList',
                        params: {
                          fittingno: item.fittingno,
                        },
                        query: { goodstype: searchData.goodstype },
                      }"
                    >
                      <p class="goods-kind">
                        {{ item.goodstype | get_club_type }}({{
                          item.clubtype_code_name
                        }})
                      </p>
                      <p class="goods-name">{{ item.goodsname }}</p>
                    </router-link>
                  </td>
                  <td class="col-auto d-lg-table-cell d-none text-start">
                    <router-link
                      :to="{
                        name: 'FittingSwingList',
                        params: { fittingno: item.fittingno },
                        query: { goodstype: searchData.goodstype },
                      }"
                    >
                      샤프트({{ item.shaftname }} /
                      {{ item.shaftmaterial | get_shaft_material }}
                      /
                      {{ item.shaftflextype | get_balance }})<br />
                      로프트 ({{ item.goodsloft || "-" }}) 라이각 ({{
                        item.goodslie || "-"
                      }}) 솔 ({{ item.goodssole || "-" }}) FP ({{
                        item.goodsfp || "-"
                      }}) 길이 ({{ item.goodslength || "-" }}) 총무게 ({{
                        item.goodsweight || "-"
                      }})
                    </router-link>
                  </td>
                  <td class="col-auto d-lg-table-cell w-1 text-center">
                    <span class="badge" :class="get_status_bg(item)">{{
                      get_status_val(item)
                    }}</span>
                  </td>
                  <td class="col-auto d-lg-table-cell d-none">
                    <MemberInfo
                      :nickname="item.nickname"
                      :playerno="item.memberno"
                    />
                  </td>
                  <td class="col-auto d-lg-table-cell d-none brand-name">
                    {{ item.fit_brand_nm }}
                  </td>
                  <td class="col-auto d-lg-table-cell d-none text-date">
                    {{ $dayjs(item.regdate).format("YYYY-MM-DD") }}
                  </td>
                  <td class="td-arrow" @click="toggle_tr(index)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="col-auto d-lg-none d-md-tabel-cell"
                  :class="{ show: view_hide === index }"
                  :key="index + 'r'"
                  v-if="view_hide === index"
                >
                  <td colspan="7">
                    <div class="toggle-content">
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.brandroom.club_infromation") }}
                        </div>
                        <div class="col-8">
                          <router-link
                            :to="{
                              name: 'FittingSwingList',
                              params: {
                                fittingno: item.fittingno,
                              },
                              query: { goodstype: searchData.goodstype },
                            }"
                          >
                            샤프트({{ item.shaftname }} /
                            {{ item.shaftmaterial | get_shaft_material }}
                            /
                            {{ item.shaftflextype | get_balance }})<br />
                            로프트 ({{ item.goodsloft || "-" }}) 라이각 ({{
                              item.goodslie || "-"
                            }}) 솔 ({{ item.goodssole || "-" }}) FP ({{
                              item.goodsfp || "-"
                            }}) 길이 ({{ item.goodslength || "-" }}) 총무게 ({{
                              item.goodsweight || "-"
                            }})
                          </router-link>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.common.nickname") }}
                        </div>
                        <div class="col-8">
                          <MemberInfo
                            :nickname="item.nickname"
                            :playerno="item.memberno"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.brandroom.brand_name") }}
                        </div>
                        <div class="col-8 brand-name">
                          {{ item.fit_brand_nm }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.common.registration_date") }}
                        </div>
                        <div class="col-8 text-date">
                          {{ $dayjs(item.regdate).format("YYYY-MM-DD") }}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label="Page navigation example"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons"
                >keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">{{
                $t("title.common.navigate_before")
              }}</i></template
            >
            <template #next-text
              ><i class="material-icons">{{
                $t("title.common.navigate_next")
              }}</i></template
            >
            <template #last-text
              ><i class="material-icons">{{
                $t("title.common.keyboard_double_arrow_right")
              }}</i></template
            >
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
        </div>
      </div>
    </div>
    <!-- //page -->
  </div>
</template>

<script>
import location from "@/components/Location";
import tab from "@/components/fitting/ListTabMain";
import ax from "@/api/fitting";
import "@/filter/common";

export default {
  name: "FittingList",
  components: {
    location,
    tab,
  },
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "G.fit_goods_nm",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        swingno: 0,
        goodstype: "",
        pagesize: 10,
        findex: "R.reg_date",
      },

      page_total: 1,
      total_cnt: 0,
      items: { fittinginfo: [] },
      view_hide: null,
      deliverySendData: { info: {}, shiplist: [] },
    };
  },
  methods: {
    get_status_val(item) {
      if (item.fittingstatus == "0") return "피팅대기";

      if (item.fittingstatus > 0) return "피팅완료";

      // if (item.fittingstatus == "2") return "배송중";

      // if (item.fittingstatus == "3") return "배송완료";
    },
    get_status_bg(item) {
      if (item.fittingstatus == "0") return "bg-secondary";

      if (item.fittingstatus > 0) return "bg-success";

      // if (item.fittingstatus == "2") return "bg-info";

      // if (item.fittingstatus == "3") return "bg-warning";
    },
    get_fittinglist() {
      (this.searchData.goodstype =
        this.$route.query.goodstype ||
        (this.$store.state.searchData[this.$route.name] &&
          this.$store.state.searchData[this.$route.name].goodstype) ||
        ""),
        this.$store.commit("setSearchData", {
          [this.$route.name]: this.searchData,
        });

      ax.get_fittinglist(this.searchData, (flag, data = "") => {
        this.total_cnt = data.pagination.fittinglistcnt;
        this.page_total = Math.ceil(
          data.pagination.fittinglistcnt / this.searchData.pagesize
        );
        this.items = data.fittinglist;

        if (!flag) alert(data.message);
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;

      this.get_fittinglist();
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },

    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_fittinglist();
  },
  watch: {
    "$route.query": function () {
      this.searchData.pageno = parseInt(this.$route.query.page) || 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_fittinglist();
    },

    "searchData.findex": function () {
      this.get_fittinglist();
    },
    "searchData.pagesize": function () {
      this.get_fittinglist();
    },
  },

  computed: {
    getGoodsType: function () {
      return this.$route.params.goodstype || "";
    },
  },
};
</script>
